export default __webpack_public_path__ + "static/media/wutzu_app.68fd378b.png";